import {ApiClient as Api} from '@hconnect/apiclient'
import {useNotification} from '@hconnect/uikit'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {CreatedCommentDto, SlaTrackingQueryKey} from '../../types'

type Props = {
  plantUpmId: string
  kpiValueId: string
}

type AddCommentParameter = {
  value: string
}

export const useAddSlaKpiComment = ({plantUpmId, kpiValueId}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()
  const {notify} = useNotification()

  return useMutation<CreatedCommentDto, AxiosError, AddCommentParameter>({
    mutationFn: async ({value}) => {
      const path = `/sla-kpi-tracking/api/${plantUpmId}/sla-kpi/tab-values/${kpiValueId}/comments`
      const response = await Api.axiosInstance.post<CreatedCommentDto>(path, value, {
        headers: {
          // Need to override content type cause axios sets it to application/x-www-form-urlencoded if plain string is passed in body
          'Content-Type': 'application/json'
        }
      })

      return response.data
    },
    onSuccess: () => {
      notify('success', t('comments.message.addSuccess'))
      void client.invalidateQueries({
        queryKey: [SlaTrackingQueryKey.SlaKpiTabValueEvents, plantUpmId, kpiValueId]
      })
      void client.invalidateQueries({queryKey: [SlaTrackingQueryKey.SlaKpiTabValues, plantUpmId]})
      void client.invalidateQueries({queryKey: [SlaTrackingQueryKey.SlaKpiComments]})
    },
    onError: () => {
      notify('error', t('comments.message.failedToAddComment'))
    }
  })
}
